import type React from 'react'

import Gallery from '@frontend/features/look-books/components/gallery/Gallery'
import PageLoader from '@frontend/features/pages/components/PageLoader'
import PageTitle from '@frontend/features/pages/components/PageTitle'
import ProductSlider from '@frontend/features/products/product-slider/ProductSlider'
import { cn } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { useState } from 'react'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'

import { useLookBook } from '../features/look-books/hooks/useLookBook'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { slug } = useParams<{ slug: string }>()
  const { data: lookBook, error, isLoading } = useLookBook().getBySlug(slug!)

  if (isLoading) return <PageLoader />

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch look book')
    showBoundary(error)
  }

  if (!lookBook) {
    showBoundary('No response data')
    return <></>
  }

  document.title = lookBook.meta.title

  const styleTag = document.getElementById('core-block-supports-inline-css')

  if (styleTag) {
    styleTag.innerHTML = lookBook.styles
  } else {
    const style = document.createElement('style')
    style.id = 'core-block-supports-inline-css'
    document.head.appendChild(style)
    style.innerHTML = lookBook.styles
  }

  return (
    <div
      className={cn({
        'mb-12': !lookBook.showTitle,
        'my-12': lookBook.showTitle,
      })}
    >
      {lookBook.showTitle && <PageTitle title={lookBook.name} />}
      {lookBook.description && (
        <p className="mx-auto mb-14 max-w-[800px]">{lookBook.description}</p>
      )}
      <div className="alignfull">
        <Gallery
          columns={{
            desktop: 3,
            mobile: 2,
            tablet: 3,
          }}
          enableLightbox
          galleryType="grid"
          gaps={{
            desktop: 15,
            mobile: 10,
            tablet: 15,
          }}
          images={lookBook.gallery}
          mobileCarousel={false}
          showNavigation={false}
          showPagination={false}
        />
      </div>
      {lookBook.product && (
        <div className="mt-16 space-y-6">
          {lookBook.product?.title && (
            <h4 className="mb-2 text-center text-2xl font-medium uppercase">
              {lookBook.product.title}
            </h4>
          )}
          {lookBook.product?.description && (
            <p className="mx-auto max-w-[800px]">
              {lookBook.product.description}
            </p>
          )}
          {lookBook.product?.categoryId && (
            <ProductSlider
              categories={lookBook.product.categoryId.toString()}
            />
          )}
        </div>
      )}
    </div>
  )
}

export function SingleLookBook(): null | React.JSX.Element {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default SingleLookBook

// const items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'];

// const ShiftMultipleSelect = () => {
//     const [selectedItems, setSelectedItems] = useState([]);
//     const [lastSelectedIndex, setLastSelectedIndex] = useState(null);

//     const handleSelect = (index, e) => {
//         const isShiftKey = e.shiftKey;
//         const isCtrlKey = e.ctrlKey || e.metaKey;

//         // Shift Select
//         if (isShiftKey && lastSelectedIndex !== null) {
//             const start = Math.min(index, lastSelectedIndex);
//             const end = Math.max(index, lastSelectedIndex);
//             const newSelection = items.slice(start, end + 1);
//             const uniqueSelection = [...new Set([...selectedItems, ...newSelection])];
//             setSelectedItems(uniqueSelection);
//         }
//         // Ctrl/Command Multiple Select
//         else if (isCtrlKey) {
//             const newSelection = selectedItems.includes(items[index])
//                 ? selectedItems.filter((item) => item !== items[index])
//                 : [...selectedItems, items[index]];
//             setSelectedItems(newSelection);
//             setLastSelectedIndex(index);
//         }
//         // Normal Click (Single Select)
//         else {
//             setSelectedItems([items[index]]);
//             setLastSelectedIndex(index);
//         }
//     };

//     return (
//         <div>
//             {items.map((item, index) => (
//                 <div
//                     key={index}
//                     onClick={(e) => handleSelect(index, e)}
//                     style={{
//                         backgroundColor: selectedItems.includes(item) ? 'lightblue' : 'white',
//                         border: '1px solid black',
//                         cursor: 'pointer',
//                         margin: '5px',
//                         padding: '10px',
//                     }}
//                 >
//                     {item}
//                 </div>
//             ))}
//         </div>
//     );
// };
